import React, { useEffect, useState, useCallback } from 'react'
import {
  CSmartTable,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CBadge,
} from '@coreui/react-pro'
import UserService from 'src/service/UserService'

const MctGameAccord4 = ({ isOpen }) => {
  console.log('isOpen', isOpen)
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState()
  const gameTypeLabels = { 1: 'Club (Outdoor)', 2: 'League', 3: 'Indoor-Cricket' }
  const columns = [
    { label: 'Game ID', key: 'id' },
    { key: 'game_name', label: 'Game Name' },
    { label: 'Hub Name', key: 'hub_name' },
    { label: 'Hub ID', key: 'hub_id' },
    { label: 'Game Privacy', key: 'game_privacy' },
    { label: 'Squad Alert', key: 'player_alert' },
    { label: 'Player Selection Limit', key: 'team_selection_limit' },
  ]

  // Wrap fetchGameData in useCallback to manage dependencies

  const fetchGameDataForAccord4 = useCallback(async () => {
    setLoading(true)
    try {
      const offset = (activePage - 1) * itemsPerPage
      const params = new URLSearchParams()
      Object.keys(columnFilter).forEach((key) => params.append(key, columnFilter[key]))
      if (columnSorter?.column)
        params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

      const result = await UserService.getMctGameAccord4Listing(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
    } catch (error) {
      console.error('Error fetching game data:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, columnFilter, columnSorter, itemsPerPage]) // Add dependencies for re-running

  useEffect(() => {
    if (isOpen) {
      console.log('from useEffect')
      fetchGameDataForAccord4()
    }
  }, [isOpen, fetchGameDataForAccord4])

  return (
    <>
      <CAccordionBody>
        <CSmartTable
          columns={columns}
          columnFilter={{ external: true }}
          columnSorter={{ external: true }}
          scopedColumns={{
            game_privacy: (item) => <td> {item?.game_privacy === 1 ? 'Public' : 'Private'}</td>,
            player_alert: (item) => <td> {item?.player_alert === 1 ? 'Yes' : 'No'}</td>,
            team_selection_limit: (item) => <td> {item?.team_selection_limit ?? 0}</td>,
          }}
          items={users?.data}
          itemsPerPage={itemsPerPage}
          itemsPerPageSelect
          loading={loading}
          pagination={{ external: true }}
          paginationProps={{
            activePage,
            pages: Math.ceil(users?.total / itemsPerPage) || 1,
          }}
          tableProps={{ hover: true, responsive: true }}
          onActivePageChange={setActivePage}
          onColumnFilterChange={(filter) => {
            setActivePage(1)
            setColumnFilter(filter)
          }}
          onItemsPerPageChange={(itemsPerPage) => {
            setActivePage(1)
            setItemsPerPage(itemsPerPage)
          }}
          onSorterChange={setColumnSorter}
        />
      </CAccordionBody>
    </>
  )
}

export default MctGameAccord4
